@if (tabs().length) {
    @if (!homeService.isExternalPage()) {
        <div class="entity-table-content">
            <div class="app-tab-container">
                @if (!isSelectedLayerHasEntities()) {
                    <div class="h-full flex items-center justify-center">
                        <app-no-data-to-display
                            displayedMessage="noDataToShow"
                            [iconSize]="'5x'" />
                    </div>
                } @else {
                    <app-tab
                        [defaultTabIndex]="currentTabIndex()"
                        [tabs]="tabs()"
                        [translateTabs]="false"
                        (changeTab)="changeTab($event)">
                        @for (tab of tabs(); track tab.name) {
                            <ng-template appTabContent>
                                <div class="overflow-x-auto">
                                    <ng-container *ngTemplateOutlet="customCreatedTableTemplate" />
                                </div>
                            </ng-template>
                        }
                    </app-tab>
                }
            </div>
        </div>
    } @else {
        <div class="overflow-auto w-full">
            <ng-container *ngTemplateOutlet="customCreatedTableTemplate" />
        </div>
    }

    <div
        class="entities-list-footer-container"
        [class.bg-white]="!homeService.isExternalPage()">
        <app-pagination-footer-template
            [canSearch]="true"
            [forceAlignment]="Alignment.ROW"
            [paginationParameters]="paginationParameters()"
            [searchDisabled]="!currentLayerEntities().length"
            [totalEntities]="currentLayerEntities().length"
            [(forceReset)]="forceResetSearchBar"
            (handleSearch)="handleSearch($event)"
            (onPageChange)="handlePageChange($event)">
            @if (isEditSessionActive()) {
                <app-button
                    [icon]="['fas', 'eye']"
                    [label]="'displayEntities' | transloco: { TYPE: 'exist' }"
                    [type]="ButtonType.SECONDARY"
                    (onClick)="switchCreatedEntitiesTable.emit()" />
            }

            @if (selectionService.isSelectionActive()) {
                <app-button
                    [icon]="['fas', 'eye']"
                    [label]="(onlySelected() ? 'displayAllEntities' : 'displayOnlySelection') | transloco"
                    (onClick)="toggleOnlySelectedEntities.emit()" />
            }
        </app-pagination-footer-template>
    </div>
}

<ng-template #customCreatedTableTemplate>
    <app-custom-table
        [columns]="tableColumns()"
        [headerCheckboxState]="headerCheckboxState()"
        [isSelectable]="isSelectableCheckbox()"
        [translateColumns]="true"
        (sortEvent)="onSort($event)"
        (toggleAllSelectedEvent)="toggleAllSelected()">
        @for (dataEntity of paginatedCurrentLayerEntities(); track dataEntity.uuid) {
            <tr (click)="openDetailEntityPanel(dataEntity)">
                @if (isSelectableCheckbox()) {
                    <td>
                        <app-checkbox
                            [checkboxState]="getSelectedRowCheckboxState(dataEntity.uuid)"
                            (click)="toggleEntitySelection(dataEntity, $event)" />
                    </td>
                }
                @for (column of tableColumns(); track column.key) {
                    <td
                        app-entity-table-cell
                        [attributeInfo]="getAttributeInformation(column.key)"
                        [businessIdentifierKey]="attributeInformationContext.businessIdentifierKey()"
                        [column]="column"
                        [dataEntity]="dataEntity"
                        [isCellEditActive]="isInlineTableEditActive()"
                        [isEditSessionActive]="isEditSessionActive()"
                        [isInlineTableEditActive]="isInlineTableEditActive()"
                        [isNumeric]="hasNumericType(column.key)"
                        [layerId]="activeLayerId()!"
                        [projectId]="getProjectId()!"></td>
                }
            </tr>
        } @empty {
            <tr>
                <td
                    class="text-center py-4"
                    [attr.colspan]="tableColumns().length">
                    <div class="w-full min-h-80 flex items-center justify-center bg-white">
                        <app-no-data-to-display
                            displayedMessage="noDataToShow"
                            [iconSize]="'5x'" />
                    </div>
                </td>
            </tr>
        }
    </app-custom-table>
</ng-template>
